import ContactView from "./ContactView";
import ContactNew from "./ContactNew";
import ContactEdit from "./ContactEdit";

export default [
  {
    path: "contacts",
    name: "clients_contacts",
    component: ContactView,
    meta: {
      toolbar: "client",
      tabAccess: "DATABASE",
    },
  },
  {
    path: "contacts_new",
    name: "clients_contacts_new",
    component: ContactNew,
    meta: {
      toolbar: "client",
      tabAccess: "DATABASE",
    },
  },
  {
    path: "contacts/:contact_id",
    name: "clients_contacts_edit",
    component: ContactEdit,
    meta: {
      toolbar: "client",
      tabAccess: "DATABASE",
    },
  },
];
